<mat-card class="explicit-confirmation-card">
  <mat-card-header>
    <mat-card-title>
      <span>{{ title | translate }}</span>
      <span fxFlex class="spacer"></span>
      <button
        mat-icon-button
        matTooltip="{{ 'General.Close' | translate }}"
        (click)="onCloseButtonClick()"
        [disabled]="isProcessing && !areAllItemsComplete()"
        [matTooltip]="isProcessing && !areAllItemsComplete() ? 'Cannot close until processing is complete' : 'General.Close' | translate"
      >
        <mat-icon>close</mat-icon>
      </button></mat-card-title
    >

    <mat-card-subtitle>
      <mat-divider class="divider"></mat-divider>
    </mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    <div class="content-container" *ngIf="dataSource">
      <div class="subtitle" style="text-align: center">
        <span *ngIf="!isAssign">{{ dataSource?.length }}</span>
        {{ subtitle | translate }}
      </div>

      <div class="subtitle notice" style="text-align: center" *ngIf="notice">
        {{ notice | translate }}
      </div>

      <!-- Progress summary - always show when real-time updates are enabled -->
      <div class="progress-summary" *ngIf="hasRealTimeUpdates() && dataSource.length > 0">
        <mat-progress-bar mode="determinate" [value]="(getCompletedCount() / dataSource.length) * 100"></mat-progress-bar>
        <div class="progress-text">
          <span>{{ getCompletedCount() }} of {{ dataSource.length }} items processed</span>
          <span *ngIf="!areAllItemsComplete()">{{ getRemainingCount() }} remaining</span>
          <span *ngIf="areAllItemsComplete()" class="complete-text">Complete</span>
        </div>
      </div>

      <!-- result table (w/header) goes here-->
      <div class="header-container">
        <app-export-to-excel-button
          (click)="exportToExcel()"
        ></app-export-to-excel-button>
      </div>
      <div class="table-container">
        <table
          mat-table
          [dataSource]="dataSource"
          #statusTable
          id="statusTable"
        >
          <ng-container
            *ngFor="let column of displayedColumns"
            [matColumnDef]="column"
          >
            <th
              mat-header-cell
              *matHeaderCellDef
              title="{{
                'MoveForms.General.' + buildColumnHeaderText(column) | translate
              }}"
            >
              {{
                'MoveForms.General.' + buildColumnHeaderText(column) | translate
              }}
            </th>
            <td
              mat-cell
              *matCellDef="let element"
              title="{{ element[column] }}"
            >
              <ng-container *ngIf="column === 'direction'">
                <span
                  class="material-icons"
                  [style.color]="getColorForDirection(element[column])"
                >
                  {{ getIconForDirection(element[column]) }}
                </span>
              </ng-container>
              <ng-container *ngIf="column === 'status'">
                <span [ngClass]="getStatusClass(element[column])">
                  <!-- Hide the status text -->
                  <span class="visually-hidden">{{ element[column] }}</span>

                  <!-- Show hourglass icon for waiting items -->
                  <mat-icon
                    *ngIf="element[column] === 'Waiting' || element[column] === 'Pending' || element[column] === 'Unknown'"
                    class="waiting-icon"
                  >
                    hourglass_empty
                  </mat-icon>

                  <!-- Show progress icon when spinner isn't showing -->
                  <mat-icon
                    *ngIf="element[column] === 'In Progress' && !(hasRealTimeUpdates() && shouldShowSpinner(element, element[column]))"
                    class="progress-icon"
                  >
                    sync
                  </mat-icon>

                  <!-- Show spinner for active processing items -->
                  <mat-spinner
                    *ngIf="hasRealTimeUpdates() && shouldShowSpinner(element, element[column])"
                    diameter="16"
                    class="inline-spinner"
                    [attr.data-item-id]="getItemId(element)"
                    [attr.data-status]="'processing'"
                  ></mat-spinner>

                  <!-- Show success icon for completed items -->
                  <mat-icon
                    *ngIf="element[column] === 'Success' || element[column] === 'Complete' || element[column] === 'Completed'"
                    class="success-icon"
                  >
                    check_circle
                  </mat-icon>

                  <mat-icon
                    *ngIf="element[column] === 'Skipped'" class="warning-icon">
                    redo
                  </mat-icon>

                  <!-- Show error icon for failed items -->
                  <mat-icon
                    *ngIf="element[column] === 'Failed' || element[column] === 'Error'"
                    class="error-icon"
                  >
                    error
                  </mat-icon>
                </span>
              </ng-container>
              <ng-container *ngIf="column !== 'direction' && column !== 'status'">
                {{ element[column] }}
              </ng-container>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
    </div>
  </mat-card-content>
  <mat-card-actions>
    <span fxFlex></span>
    <button
      mat-button
      class="add-new-item-button"
      (click)="onToListButtonClick()"
      *ngIf="showToListButton"
      [disabled]="isProcessing && !areAllItemsComplete()"
    >
      {{ 'MoveForms.General.ToTankList' | translate }}
    </button>
    <button
      mat-button
      color="primary"
      (click)="onCloseButtonClick()"
      [disabled]="isProcessing && !areAllItemsComplete()"
      [matTooltip]="isProcessing && !areAllItemsComplete() ? 'Cannot close until processing is complete' : ''"
    >
      <ng-content *ngIf=""></ng-content>
      {{ buttonText ?? 'MoveForms.General.GotIt' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
